import React from "react";

export default function EditIcon() {
  return (
<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_81_3044)">
<path d="M3.83301 16.6668H7.16634L15.9163 7.91676C16.1352 7.69789 16.3088 7.43805 16.4273 7.15208C16.5457 6.86612 16.6067 6.55962 16.6067 6.25009C16.6067 5.94056 16.5457 5.63406 16.4273 5.3481C16.3088 5.06213 16.1352 4.80229 15.9163 4.58342C15.6975 4.36455 15.4376 4.19094 15.1517 4.07248C14.8657 3.95403 14.5592 3.89307 14.2497 3.89307C13.9401 3.89307 13.6336 3.95403 13.3477 4.07248C13.0617 4.19094 12.8019 4.36455 12.583 4.58342L3.83301 13.3334V16.6668Z" stroke="#878787" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M11.75 5.41675L15.0833 8.75008" stroke="#878787" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
</g>
<defs>
<clipPath id="clip0_81_3044">
<rect width="20" height="20" fill="white" transform="translate(0.5)"/>
</clipPath>
</defs>
</svg>

  );
}
